import React from "react";
import NavBar from "../NavBar";
import { Typography, Button } from "@material-ui/core";
import "../../Style/Result.css";
import Twitter from "../../Components/RedesSociales/botonTwitter";
import Facebook from "../../Components/RedesSociales/botonFacebook";
import ImageRodrigo from "../../assets/rodri.png"

const Result = ({ diasATrabajar, idResult }) => {

  const handleClick = () => {
    window.location.href = `/calculator`;
  }

  return (
    <div className="Result">
      <NavBar />
<div className="ResultContent">
<div className="ResultContent__Result" >
          
          <span className="Result-Information__Result--Text">El estado provincial y municipal se queda con&nbsp;
          </span>
          <span className="Result-Information__Result--Days">
            {`${Math.round(diasATrabajar)} días`}&nbsp;
          </span>
          <span className="Result-Information__Result--Text">de tu sueldo.<br/> Trabajás todos esos días sólo para pagar sus impuestos. Si sumaras los impuestos nacionales duplicarías los días trabajados para poder únicamente pagar impuestos. </span>
        </div>

</div>

      <div className="ResultContent">
        

       
        <div className="Result-Container__Compartir">
        <img
        className="Result-Image"
        src={ImageRodrigo}
      ></img>
      <div className="Result-Redes__Compartir">
        <Typography className="Result-Title__Compartir">Compartir</Typography>
           <div className="Result-Information__Compartir">

          <Twitter d={Math.round(diasATrabajar)}></Twitter>
          <Facebook d={`https://calculadoraimpuestos-158e5.web.app/result/${idResult}/${diasATrabajar}`}></Facebook>
        </div>
      </div>
       
        </div>
       

        <Typography className="Result-Obligatorio">El resultado obtenido es aproximado según la información cargada por el usuario y para su cálculo se incluyen las contribuciones de Córdoba capital e impuestos de la Provincia. Si querés obtener más información sobre el cálculo que realizamos no dudes en contactarte con nosotros vía mail a dimensionatuesfuerzo@gmail.com</Typography>
      </div>

<div className="Result-Boton">
  <Button
              onClick={handleClick}
              size="large"
              variant="contained"
            >
              Volver a calculadora
            </Button>
</div>
      
    </div>
  );
};

export default Result;